module.exports = __webpack_public_path__ + "static/media/action.736a0767.svg";